import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import QuantitySelector from "./QuantitySelector";
import { useTranslation } from "react-i18next";
import { breakdownFromEvent } from "./PriceCalculator";
import PriceBreakdown from "./PriceBreakdown";
import { HeartIcon } from "@heroicons/react/24/solid";

export default function EventTicketPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [event, setEvent] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/event/${id}`)
      .then((res) => res.json())
      .then((data) => {
        setEvent(data);
        setLoading(false);
      })
      .catch(() => {
        setError("Événement introuvable.");
        setLoading(false);
      });
  }, [id]);

  const handleBuy = async () => {
    // Appel à ton endpoint Stripe pour créer une sessionww
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/eventticket/create-checkout-session`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          eventId: id,
          quantity,
        }),
      }
    );

    const data = await response.json();
    if (data.sessionUrl) {
      window.location.href = data.sessionUrl;
    }
  };

  if (loading) return <p className="text-center p-6">{t("loading")}</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;

  const priceBreakdown = breakdownFromEvent(event);

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-primary">
      {/* Image en haut */}
      <div className="w-full max-h-72 overflow-hidden flex justify-center items-center bg-gray-200 rounded-t-xl">
        <img src={event.imageUrl} alt={event.name} className="h-full w-auto" />
      </div>

      {/* Contenu */}
      <div className="bg-white p-6 rounded-b-xl shadow-md">
        <h1 className="text-2xl font-bold mb-2">{event.name}</h1>

        {event.description && (
          <p className="text-gray-700 mb-4 whitespace-pre-line">
            {event.description}
          </p>
        )}

        <p className="mb-1">
          <strong>Date :</strong>{" "}
          {new Date(event.eventDate).toLocaleDateString("fr-CA", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>

        <p className="mb-1">
          <strong>Heure :</strong>{" "}
          {new Date(event.eventDate).toLocaleTimeString("fr-CA", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>

        <p className="mb-1">
          <strong>Prix :</strong> {priceBreakdown.totalPrice.toFixed(2)}$
        </p>

        {/* Quantité */}
        <div className="mt-6">
          <label className="font-semibold block mb-2">Quantité</label>
          <QuantitySelector max={10} value={quantity} onChange={setQuantity} />

          <div className="mt-4">
            <PriceBreakdown calc={priceBreakdown} quantity={quantity} />
          </div>

          <button
            onClick={handleBuy}
            className="bg-primary mt-4 text-white py-3 px-6 rounded-full hover:bg-primary/90 transition w-full"
          >
            {t("ticketing.buyTickets")}
          </button>
        </div>
      </div>
    </div>
  );
}
